export enum CriteriaSteps {
  CriteriaSelect = 'criteriaSelect',
  CriteriaResult = 'criteriaResult',
}
